import styled from 'styled-components';
export const DatePickerWrapperStyled = styled.div `
  display: flex;
  flex-direction: column;
  gap: 28px;
  align-items: center;
  position: relative;
  width: ${({ dynamicWidth }) => dynamicWidth};
`;
//# sourceMappingURL=styled.js.map